import Icon from "./IconBase.js";
const EbookIcon = (props) => {
  return (
    <Icon width="18" height="18" viewBox="0 -2 18 18" {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0815 0.5H10.0672C9.86993 0.5 9.67413 0.533015 9.48873 0.597663L8.42743 0.96735C8.20332 1.0453 7.95748 1.0453 7.73337 0.96735L6.67181 0.597663C6.48641 0.533015 6.29061 0.5 6.09336 0.5H2.07899C1.14858 0.501004 0.394608 1.21992 0.393555 2.10679V10.3676C0.394608 11.2545 1.14858 11.9732 2.07899 11.9744H6.09336C6.21174 11.9742 6.32932 11.9941 6.44059 12.0329L7.50202 12.4026C7.87558 12.5325 8.28522 12.5325 8.65878 12.4026L9.72021 12.0329C9.83148 11.9941 9.94907 11.9742 10.0674 11.9744H14.0815C15.012 11.9732 15.7659 11.2545 15.767 10.3676V2.10679C15.7659 1.21979 15.012 0.501004 14.0815 0.5ZM6.67169 11.4289C6.48643 11.3643 6.29063 11.3313 6.09338 11.3314H2.07901C1.52071 11.3308 1.0684 10.8996 1.06775 10.3673V2.10678C1.0684 1.57465 1.52071 1.14333 2.07901 1.1427H6.09338C6.21175 1.1427 6.32934 1.16254 6.4406 1.20133L7.50204 1.57089C7.58065 1.59813 7.66123 1.61984 7.74313 1.63566V11.8019L7.73313 11.7987L6.67169 11.4289ZM14.0814 11.3317C14.6396 11.331 15.092 10.8997 15.0927 10.3676V2.10693C15.092 1.57468 14.6396 1.14348 14.0814 1.14286H10.067C9.94867 1.14273 9.83109 1.16256 9.71995 1.20135L8.65839 1.57104C8.57978 1.59841 8.49907 1.62 8.41703 1.63582V11.802L8.42717 11.7988L9.4886 11.4292C9.674 11.3646 9.8698 11.3315 10.067 11.3317H14.0814Z"
          fill="#757575"
        />
        <path
          d="M2.32 4.05824H4.98352C5.1697 4.05824 5.3206 3.91439 5.3206 3.73689C5.3206 3.55939 5.1697 3.41553 4.98352 3.41553H2.32C2.13381 3.41553 1.98291 3.55939 1.98291 3.73689C1.98291 3.91439 2.13381 4.05824 2.32 4.05824Z"
          fill="#757575"
        />
        <path
          d="M6.33187 5.08228H2.32C2.13381 5.08228 1.98291 5.22613 1.98291 5.40363C1.98291 5.58113 2.13381 5.72499 2.32 5.72499H6.33187C6.51805 5.72499 6.66895 5.58113 6.66895 5.40363C6.66895 5.22613 6.51805 5.08228 6.33187 5.08228Z"
          fill="#757575"
        />
        <path
          d="M6.33187 6.74902H2.32C2.13381 6.74902 1.98291 6.89288 1.98291 7.07038C1.98291 7.24788 2.13381 7.39174 2.32 7.39174H6.33187C6.51805 7.39174 6.66895 7.24788 6.66895 7.07038C6.66895 6.89288 6.51805 6.74902 6.33187 6.74902Z"
          fill="#757575"
        />
        <path
          d="M6.33187 8.41577H2.32C2.13381 8.41577 1.98291 8.55976 1.98291 8.73713C1.98291 8.91463 2.13381 9.05849 2.32 9.05849H6.33187C6.51805 9.05849 6.66895 8.91463 6.66895 8.73713C6.66895 8.55976 6.51805 8.41577 6.33187 8.41577V8.41577Z"
          fill="#757575"
        />
      </svg>
    </Icon>
  );
};
export default EbookIcon;
